module.exports = __webpack_public_path__ + "media/assets/images/blog/just-in-time-mac-2631e28d23a09496f48fa287e7c580a0.jpg";